class PasswordProtect extends HTMLElement {
  constructor() {
    super();

    this.body = document.querySelector('body');
    this.interval = setInterval(() => {
      bodyScrollLock.disableBodyScroll(this);
      this.disableZoom();
    }, 10);

    setTimeout(() => {
      clearInterval(this.interval);
    }, 1000);

    this.sectionId = this.getAttribute('data-section-id');
    this.message = sessionStorage.getItem(`password-protect-${this.sectionId}`);
    this.input = this.querySelector('.password-protect__input');
    this.password = this.input.getAttribute('data-value');
    this.button = this.querySelector('.password-protect__button');

    document.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        if (!this.button.disabled) {
          this.button.click();
        }
      }
    });

    if (this.message !== this.password) {
      this.style.display = 'flex';
      this.error = this.querySelector('.password-protect__error');

      this.button.addEventListener('click', () => {
        this.inputValue = this.input.value;
        if (this.inputValue === this.password) {
          sessionStorage.setItem(`password-protect-${this.sectionId}`, this.password);
          window.scrollTo(0, 0);
          this.style.display = 'none';
          this.enableZoom();
          setTimeout(() => {
            bodyScrollLock.clearAllBodyScrollLocks();
          }, 10);
        } else {
          this.error.style.opacity = '1';

          setTimeout(() => {
            this.error.style.opacity = '0';
          }, 3000);
        }
      })
    } else {
      clearInterval(this.interval);
      bodyScrollLock.clearAllBodyScrollLocks();
      this.enableZoom();
    }
  }

  disableZoom() {
    this.body.style.touchAction = 'none';
  }

  enableZoom() {
    this.body.style.touchAction = 'auto';
  }
}

customElements.define('password-protect', PasswordProtect);